// import { SharedReducer, SharedState }  from 'wt-front-shared';
import { SharedReducer, SharedState } from 'wt-front-shared';

export interface AppState extends SharedState {
}

export const coreReducer = {
  ...SharedReducer,
}
